import { TaskExperience } from '@dialogue/silkroad'

/**
 * List of member task types that the app supports.
 */
export const SUPPORTED_MEMBER_TASK_TYPES = [TaskExperience.BookAppointment] as const

export type SupportedMemberTaskType = (typeof SUPPORTED_MEMBER_TASK_TYPES)[number]

/**
 * Time-to-live for member tasks in the store before they are considered stale.
 *
 * ie: 1 minute
 */
export const MEMBER_TASKS_STALE_TTL_MS = 60 * 1000
